import { formatUnits, parseUnits } from 'ethers'

export function parseHumanToAtomic(amountStr: string, decimals = 18): string {
  const normalized = (amountStr ?? '').trim()
  // Allow inputs like "1", "1.", "1.23", and ".5" while requiring at least
  // one digit somewhere in the string.
  if (!normalized || !/^(\d+(\.\d*)?|\.\d+)$/.test(normalized)) {
    throw new Error('Invalid amount')
  }

  // Normalize forms like ".5" -> "0.5" and "1." -> "1.0" before parsing
  let toParse = normalized
  if (toParse.startsWith('.')) toParse = `0${toParse}`
  if (toParse.endsWith('.')) toParse = `${toParse}0`

  try {
    return parseUnits(toParse, decimals).toString()
  } catch {
    throw new Error('Invalid amount')
  }
}

export function formatAtomicToHuman(
  amountAtomic: string | number | bigint,
  decimals = 18,
): string {
  return formatUnits(String(amountAtomic ?? '0'), decimals)
}

export function isValidHumanAmount(amountStr: string, decimals = 18): boolean {
  try {
    parseHumanToAtomic(amountStr, decimals)
    return true
  } catch {
    return false
  }
}

export function isPositiveDecimalAmount(value?: string | null): boolean {
  const normalized = value?.trim()

  return Boolean(
    normalized &&
    /^\d+(?:\.\d+)?$/.test(normalized) &&
    /[1-9]/.test(normalized),
  )
}
